import { render, staticRenderFns } from "./Blockie.vue?vue&type=template&id=67cefb5d&scoped=true&"
import script from "./Blockie.vue?vue&type=script&lang=js&"
export * from "./Blockie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cefb5d",
  null
  
)

export default component.exports